import { render, staticRenderFns } from "./Shipin.vue?vue&type=template&id=8cb8efe4&"
import script from "./Shipin.vue?vue&type=script&lang=js&"
export * from "./Shipin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports